<button
  class="export-button"
  [ngClass]="{ 'export-button-loading': this.waitingForFile }"
  (click)="exportToCSV()"
  [matTooltip]="'common.inventoryExportToolTip' | labelsProvider"
  matTooltipPosition="below"
  matTooltipClass="tooltip-container"
>
  <img *ngIf="!waitingForFile" src="assets/images/common/export.svg" alt="export" />
  <div *ngIf="!this.waitingForFile && !this.displayCheckMark">
    {{ 'common.export' | labelsProvider }}
  </div>
  <mat-progress-spinner class="export-button-spinner" *ngIf="this.waitingForFile" color="primary" mode="indeterminate">
  </mat-progress-spinner>
  <div *ngIf="this.displayCheckMark">
    <img src="assets/images/common/checked.svg" />
  </div>
</button>
